import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import Configuration from '../entities/configuration';
import Reservation from '../entities/reservation';
import Customer from '../entities/customer';
import Step from '../components/choose-slot/entities/step';
import Slot from '../entities/slot';
import Location from '../entities/locations';
import * as _  from 'lodash';


import { map } from 'rxjs/operators';
import { Lang } from '../entities/enums/lang';

@Injectable()
export class AppService {

   static MAKE_RESERVATION = 'slot/v1/${date}/CASH/1';

   private TAG = '[AppService]';

   get host() { return environment.host; }
   get prefix() { return environment.prefix; }
   get apiVersion() { return environment.apiUrl; }

   private configurationDataSource: BehaviorSubject<Configuration> = new BehaviorSubject<Configuration>(null);
   public configurationData: Observable<Configuration> = this.configurationDataSource.asObservable();

   private reservationDataSource: BehaviorSubject<Reservation> = new BehaviorSubject<Reservation>(null);
   public reservationData: Observable<Reservation> = this.reservationDataSource.asObservable();

   private reservationJWTSource: Subject<string> = new Subject<string>();
   public reservationJWT: Observable<string> = this.reservationJWTSource.asObservable();

   private createLocationRequestSource: Subject<boolean> = new Subject<boolean>();
   public createLocationRequest: Observable<boolean> = this.createLocationRequestSource.asObservable();

   public lang: Lang = Lang.PL;

   private reservation: Reservation = new Reservation();

   public configuration = {"userToken":"eyJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJnZGZnc2RmIiwic3RhdHVzIjoiTkVXIiwiaXNzIjoicGFydG5lciIsImF1ZCI6Ik9wZW4gUm91dGluZyIsImlhdCI6MTU1MTQ0OTUxMCwiZXhwIjoxNTUxNDUzMTEwfQ.aw9bvcOfAb08LZHMEC73gPJ_W4lLCfkBkzuB4GdYKmM","locationList":[{"additional":{"contactPhoneNO":"","domofonCode":"","flatNO":"","floor":0,"lift":0,"staircaseNO":""},"address":{"country":"Poland","district":"Warszawa","houseNO":"35","street":"Bajana 1","town":"Warszawa","voivoidship":"Warszawa","zip":"01-905"},"coordinates":{"lat":"52.2744999","lng":"20.9341799"},"label":"Dom","locationId":"125a7eae-e39f-460a-b26b-6deabb991452","locationRef":"125a7eae-e39f-460a-b26b-6deabb991452"},{"additional":{"companyName":"Openlane","contactName":"Dom","contactPhoneNO":"","domofonCode":"","flatNO":"","floor":0,"lift":0,"staircaseNO":""},"address":{"country":"Poland","district":"Piaseczno","houseNO":"207","street":"Puławska 45","town":"Piaseczno","voivoidship":"Piaseczno","zip":"05-500"},"coordinates":{"lat":"52.0905938","lng":"21.0173026"},"label":"Mamusia","locationId":"1261a7c9-4951-455a-9fbf-f417fa95953d","locationRef":"1261a7c9-4951-455a-9fbf-f417fa95953d"},{"additional":{"companyName":"Yearin","contactName":"Mamusia","contactPhoneNO":"","domofonCode":"","flatNO":"","floor":0,"lift":0,"staircaseNO":""},"address":{"country":"Poland","district":"Warszawa","houseNO":"1","street":"Wał Miedzeszyński 3","town":"Warszawa","voivoidship":"Warszawa","zip":"01-001"},"coordinates":{"lat":"52.1525082","lng":"21.1876677"},"label":"Dom Babci","locationId":"12736523-4377-48c9-8ec9-5f8ab9638b01","locationRef":"12736523-4377-48c9-8ec9-5f8ab9638b01"},{"additional":{"companyName":"Openlane","contactName":"Dom","contactPhoneNO":"","domofonCode":"","flatNO":"","floor":0,"lift":0,"staircaseNO":""},"address":{"country":"Poland","district":"Warszawa","houseNO":"26","street":"Korkowa 61","town":"Warszawa","voivoidship":"Warszawa","zip":"04-549"},"coordinates":{"lat":"52.2412713","lng":"21.1586104"},"label":"Dom Babci 2","locationId":"12769c45-1596-4343-aa79-73d298885e84","locationRef":"12769c45-1596-4343-aa79-73d298885e84"},{"additional":{"companyName":"Condax","contactName":"Dom Babci 2","contactPhoneNO":"","domofonCode":"","flatNO":"","floor":0,"lift":0,"staircaseNO":""},"address":{"country":"Poland","district":"Warszawa","houseNO":"127","street":"Obrońców Tobruku 2","town":"Warszawa","voivoidship":"Warszawa","zip":"01-001"},"coordinates":{"lat":"52.2550594","lng":"20.9315999"},"label":"Do pracy","locationId":"127c8084-2456-4056-ba32-806dac5ae778","locationRef":"127c8084-2456-4056-ba32-806dac5ae778"}],"selectedLocation":{"additional":{"contactPhoneNO":"","domofonCode":"","flatNO":"","floor":0,"lift":0,"staircaseNO":""},"address":{"country":"Poland","district":"Warszawa","houseNO":"35","street":"Bajana 1","town":"Warszawa","voivoidship":"Warszawa","zip":"01-905"},"coordinates":{"lat":"52.2744999","lng":"20.9341799"},"label":"Dom","locationId":"125a7eae-e39f-460a-b26b-6deabb991452","locationRef":"125a7eae-e39f-460a-b26b-6deabb991452"},"basketAmount":100,"mode":"NEW","customer":{"customerId":"customer:08fc4732-188b-4a40-b506-c8a601b11cba","customerRef":"gdfgsdf","firstName":"Madie","lastName":"Mauch","phoneNumber":"1","status":"NEW"},"shown1":false,"shown2":false,"jwt":"\"eyJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJnZGZnc2RmIiwic3RhdHVzIjoiTkVXIiwiaXNzIjoicGFydG5lciIsImF1ZCI6Ik9wZW4gUm91dGluZyIsImlhdCI6MTU1MTQ0OTUxMCwiZXhwIjoxNTUxNDUzMTEwfQ.aw9bvcOfAb08LZHMEC73gPJ_W4lLCfkBkzuB4GdYKmM\""}

   constructor(private http: HttpClient) { }

   loadConfigurationData(configurationFromPartnerStore): boolean {
      /*
       *  Parsed configuration model
       */
      const configuration: Configuration = new Configuration().deserialize(configurationFromPartnerStore);

      if (configuration.isValid) {
         this.lang = configuration.lang;
         console.warn(`${this.TAG} Parse configuration data`, configuration);
         this.configurationDataSource.next(configuration);
         /*
          * Initialize and fill finall reservation model
          */
         this.reservation.customer = new Customer().deserialize(configuration.customer);
         this.reservation.location = new Location().deserialize(configuration.selectedLocation);

         this.reservationDataSource.next(configuration.reservation);

         return true;
      } else {
         return false;
      }
   }

   setSlot(slot: Step, date: string): void {
       /**
         * Setting selected slot by user in reservation data model.
         *
         * @param slot - Selected slot by user
         * @returns void
         *
         */
      if (_.isUndefined(slot)) {
         return;
      }

      if (_.isNull(slot)) {
         this.reservation.slot = null;
         this.reservationJWTSource.next(null);
         this.reservationDataSource.next(this.reservation);
         return;
      }

      this.reservation.slot = new Slot().deserialize(slot);
      this.reservationDataSource.next(this.reservation);

      this.makeReservation(date);
      console.warn(`${this.TAG} Updated reservation model`, this.reservation);
   }

   strechSlot(time: string, direction: string): void {
      if (direction === 'startTime') {
         this.reservation.slot.startTime = time;
      } else if (direction === 'endTime') {
         this.reservation.slot.endTime = time;
      }

      this.reservationDataSource.next(this.reservation);
      this.makeReservation(this.reservation.slot.date).subscribe();
      console.warn(`${this.TAG} Updated reservation model, strech slot time`, this.reservation);
   }

   public makeReservation(date: string): Observable<any> {

      const endpoint = this.interpolate(`${this.host}${this.prefix}/${AppService.MAKE_RESERVATION}`,
         { date: date });

      const body = JSON.stringify(this.reservation);

      return this.http.post(endpoint, body, {responseType: 'text' as 'json'})
         .pipe(
            map((response: any) => {
               const jwt = JSON.stringify(response);
               this.reservationJWTSource.next(jwt);
               return jwt;
            })
         );
   }

   public locationsCreated() {
      this.createLocationRequestSource.next(true);
   }

   public changeConfigurationByUser(configuration: Configuration) {
      if (configuration.isValid) {
         console.log(`${this.TAG} Changed configuration during using picker by user`, configuration);
         this.configurationDataSource.next(configuration);
      } else {
         console.error(`${this.TAG} INVALID CONFIGURATION - Changed configuration during using picker by user`, configuration);
      }
   }

   public interpolate(template: string, params: {}) {
      const names = Object.keys(params);
      const vals = Object.keys(params).map(key => params[key]);
      return new Function(...names, `return \`${template}\`;`)(...vals);
   }
}
